import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async importFile(item) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.CONVERT_INTERFACE_FILE}/convert/${Enviroment.LANGUAGE}/${item.interface}?headers=${item.headers}`,
			headers: {
				'Content-Type': 'multipart/form-data',
				token: item.token,
			},
			data: item.form,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async generatePharmacy(pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.GENERATE_PHARMACY}/pharmacy/migration/${Enviroment.LANGUAGE}/${pharmacy}`,
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
